import { useQuery } from "@apollo/client/react";
import { useEffect, useState } from "react";
import { IKeyContactInformation, KeyContactInformationProps } from "../context/model";
import { KEY_CONTACT_INFORMATION_QUERY } from "../services/query";
import { useAppContext } from "../provider/AppContextProvider";

export const useFetchKeyContactData = () => {
  const { updateLoading, dashboardListId, isInitializing } = useAppContext();
  const [contacts, setContacts] = useState<KeyContactInformationProps[]>([]);

  const { error, data, loading } = useQuery<IKeyContactInformation>(
    KEY_CONTACT_INFORMATION_QUERY,
    {
      skip: !dashboardListId || dashboardListId.length === 0 || isInitializing,
      variables: { dashboardListId },
    }
  );

  useEffect(() => {
    if (data && data.cAContactInfoCollection) {
      const contact = data.cAContactInfoCollection.items
        .filter((item) => item.dashboard.items.length > 0)
        .slice(0, 2);

      if (contact.length === 0) {
        setContacts([]);
        return;
      }
      setContacts(contact);
    }
  }, [data, error]);

  // Email validation helper
  const isValidEmail = (email: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  // Generate comma-separated email addresses for mailto link
  const getEmailAddresses = () => {
    return contacts
      .map((contact) => contact.email)
      .filter(
        (email) => email && email.trim() !== "" && isValidEmail(email.trim())
      )
      .join(",");
  };

  return {
    contacts,
    loading,
    error,
    isValidEmail,
    getEmailAddresses,
    updateLoading
  };
};
